import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
export var logo = {
  letterSpacing: '-0.02em',
  fontWeight: 600,
  fontSize: 4
};

if (typeof logo !== 'undefined' && logo && logo === Object(logo) && Object.isExtensible(logo) && !logo.hasOwnProperty('__filemeta')) {
  Object.defineProperty(logo, '__filemeta', {
    configurable: true,
    value: {
      name: "logo",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Logo/styles.js"
    }
  });
}

export var link = {
  fontWeight: 600,
  color: 'header.text',
  textDecoration: 'none',
  ':hover': {
    color: 'primary'
  }
};

if (typeof link !== 'undefined' && link && link === Object(link) && Object.isExtensible(link) && !link.hasOwnProperty('__filemeta')) {
  Object.defineProperty(link, '__filemeta', {
    configurable: true,
    value: {
      name: "link",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Logo/styles.js"
    }
  });
}